import React from 'react';
import { motion } from 'framer-motion';

export default function SplitText({ text, style, wordStyle, delay = 0, stagger = 0.07 }) {
  const words = text.split(' ');
  return (
    <span style={{ display: 'inline-block', ...style }}>
      {words.map((word, i) => (
        <motion.span
          key={i}
          initial={{ opacity: 0, y: '60%', clipPath: 'inset(0 0 100% 0)' }}
          whileInView={{ opacity: 1, y: '0%', clipPath: 'inset(0 0 0% 0)' }}
          viewport={{ once: true }}
          transition={{ duration: 0.45, delay: delay + i * stagger, ease: [0.22, 1, 0.36, 1] }}
          style={{ display: 'inline-block', marginRight: '0.28em', ...wordStyle }}
        >
          {word}
        </motion.span>
      ))}
    </span>
  );
}
